import { render, staticRenderFns } from "./TableReject.vue?vue&type=template&id=bf7c8126&"
import script from "./TableReject.vue?vue&type=script&lang=ts&"
export * from "./TableReject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports